import { useState } from "react";

/**
 * One shop tile. The logo is optional, so the name has to carry the tile on its
 * own when there is no image — and when an image 404s, which is what the error
 * fallback covers.
 */
const ShopCard = ({ shop }) => {
   const [broken, setBroken] = useState(false);
   const src = shop.img
      ? `${process.env.REACT_APP_API_URL}/storage/${shop.img}`
      : null;

   return (
      <a
         href={shop.url}
         target="_blank"
         rel="noopener noreferrer"
         title={shop.name}
         className="border-2 border-[#F0F0F0] rounded-[20px] p-4 sm:p-3 flex flex-col items-center
            justify-center gap-2 h-28 hover:border-teal_600 hover:shadow-sm transition-all"
      >
         {src && !broken ? (
            <img
               src={src}
               alt={shop.name}
               onError={() => setBroken(true)}
               className="max-h-12 max-w-full object-contain"
            />
         ) : (
            <span className="text-teal_600 font-bold text-lg">
               {shop.name.trim().charAt(0).toUpperCase()}
            </span>
         )}
         <span className="text-xs font-semibold text-center text-black_900 line-clamp-2 break-words">
            {shop.name}
         </span>
      </a>
   );
};

export default ShopCard;
